module.exports = __webpack_public_path__ + "static/media/logo.bdcd011d.gif";